import { DEFAULT_ERROR_MESSAGE } from 'shared/enums/ErrorMessage';
import { ErrorType } from 'shared/enums/ErrorType';
import { getTranslations } from 'shared/utils/getTranslations';

export class ResourceError extends Error {
  response: Error & { isPotentialBot?: boolean };

  constructor(response) {
    super(response);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResourceError);
    }
    const defaultErrorMessage = getTranslations(DEFAULT_ERROR_MESSAGE);
    const message =
      response?.data?.localized_messages?.[0] ||
      response?.data?.messages?.[0] ||
      defaultErrorMessage;

    this.name = ErrorType.ResourceError;
    this.message = message;
    this.response = {
      ...response,
      name: ErrorType.ResourceError,
      message,
      // Explicitly preserve the isPotentialBot flag
      isPotentialBot: !!response?.isPotentialBot,
    };
  }
}
